module.exports = __webpack_public_path__ + "img/a0309_6.d56f7291.png";